export default __webpack_public_path__ + "static/BayswaterCarousel_0005-5385319ac8528723ee4d816f5f66cc46.jpg";